/**
 * Global toast manager for Parent API
 * Uses event system to communicate with ToastBridge component
 */
class ToastManager {
  constructor() {
    this.listeners = [];
    this.toastId = 0;
  }

  /**
   * Subscribe to toast events
   * @param {Function} callback - Called when toast should be shown: (toast) => void
   * @returns {Function} Unsubscribe function
   */
  subscribe(callback) {
    this.listeners.push(callback);
    return () => {
      this.listeners = this.listeners.filter(l => l !== callback);
    };
  }

  /**
   * Show a toast notification
   * @param {string} message - Toast message
   * @param {string} type - Toast type: 'success', 'error', 'info', 'warning'
   * @param {number} duration - Duration in ms (optional, uses defaults if not provided)
   */
  show(message, type = 'info', duration = null) {
    // Default durations based on type
    if (duration === null) {
      duration = type === 'error' ? 8000 : type === 'success' ? 4000 : 5000;
    }

    const toast = {
      id: ++this.toastId,
      message,
      type,
      duration,
      timestamp: Date.now()
    };

    // Notify all listeners
    this.listeners.forEach(listener => {
      try {
        listener(toast);
      } catch (error) {
        console.error('[ToastManager] Listener error:', error);
      }
    });
  }
}

// Singleton instance
export const toastManager = new ToastManager();

